import React from 'react'
import { Modal } from 'react-bootstrap'
import Failed from 'assets/images/svg/payment_failed.svg'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
const PaymentFailed = ({ show, onHide, ...props }) => {
    const { t } = useTranslation("browse-apps");

  return (
    <div className=''> 
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    show={show}
    onHide={onHide}
    className='all-modal fawry paymentApproved'
>
    <Modal.Body>
        <div className='header'>

        </div>
        <div className='row'>
            <div className='col-md-12'>
                <img className='fawryIcon' src={Failed} alt="Failed" />
                <h1 className='title'>{t("paymentDetails.paymentMessage.paymentFail")}</h1>
                <p className='order-info'>{t("paymentDetails.paymentMessage.paymentFailInfo")}</p>
            </div>

   
            <div className='col-12'>
                <button className='btn-blue' onClick={onHide}>{t("paymentDetails.paymentMessage.ok")}</button>
            </div>
        </div>
    </Modal.Body>
</Modal>
</div>
  )
}

export default PaymentFailed